import { AccessType, Roles } from "../../../helpers/Common";

const defaultReadOnly = {
  description: {
    readOnly: true,
  },
  plantaZonaId: {
    readOnly: true,
  },
  isWarehouse: {
    readOnly: true,
  },
  formButtons: {
    hidden: true,
  },
  addSubZoneButton: {
    hidden: true,
  },
  driveCRUD: {
    create: false,
    read: true,
    update: false,
    delete: false,
  },
};

const defaultManager = {
  description: {
    readOnly: false,
  },
  plantaZonaId: {
    readOnly: false,
  },
  isWarehouse: {
    readOnly: false,
  },
  formButtons: {
    hidden: false,
  },
  addSubZoneButton: {
    hidden: false,
  },
  driveCRUD: {
    create: true,
    read: true,
    update: true,
    delete: true,
  },
};

function calculateFromFormValues(result, zone) {
  return result;
}

function calculateFromRolAndAccess(result, role, zonaAccess) {
  switch (role) {
    case Roles.Admin:
      result = defaultManager;
      break;
    case Roles.DSC:
    case Roles.Partner:
    case Roles.EndCustomer:
      if (zonaAccess?.accessType === AccessType.Manager && !zonaAccess?.isZoneManager) {
        result = defaultManager;
      } else {
        result = defaultReadOnly;
      }
      break;
    default:
      result = defaultReadOnly;
      break;
  }

  return result;
}

function getZonaDetailsView(accessPR, zonaAccess, zone) {
  let result = null;

  result = calculateFromRolAndAccess(
    result,
    accessPR.userRole,
    zonaAccess
  );
  result = calculateFromFormValues(result, zone);

  return result;
}

export default getZonaDetailsView;
